import React from 'react';
import * as _ from 'lodash';
import {
  SYSTEM_WORKER_COUNT,
  SYSTEM_WORK_TIME,
  WORKING_TEMP_HOUR,
  WORK_DAY_WORKER_STATUS,
} from '../utilities/constants';
import { ArrowDownIcon } from './icons/ArrowDownIcon';
import { TrashIcon } from './icons/TrashIcon';

export const WorkDayTime = ({
  workDayworkers,
  workTime,
  isFifteen,
  callbacks,
  validate,
  readOnly,
  errors,
  isWorkHourModal = false,
  status,
}) => (
  <div>
    {_.map(workDayworkers, (worker, index) => (
      <Line
        key={index}
        foreignKey={index}
        workTime={workTime}
        worker={worker}
        isFifteen={isFifteen}
        callbacks={callbacks}
        validate={validate}
        readOnly={readOnly}
        errors={errors}
        isWorkHourModal={isWorkHourModal}
        status={status}
      />
    ))}
    {!readOnly && (
      <div className='form-container__item form-list__man-hours-btn--add'>
        <button className='btn--sub' onClick={() => callbacks.add()}>
          入力枠を追加する
        </button>
      </div>
    )}
  </div>
);

const Line = ({
  foreignKey,
  workTime,
  worker,
  isFifteen,
  callbacks,
  validate,
  readOnly,
  errors,
  isWorkHourModal = false,
  status,
}) => {
  const Time = isFifteen ? SYSTEM_WORK_TIME : WORKING_TEMP_HOUR;
  if (_.isEmpty(workTime)) {
    return false;
  }
  let period = workTime[sessionStorage.getItem('work_hour_zone')].working_time;
  const minute = period.slice(3, 5);
  if (minute == '00') {
    period = `${period.slice(0, 2)}.00`;
  } else if (minute == '15') {
    period = `${period.slice(0, 2)}.25`;
  } else if (minute == '30') {
    period = `${period.slice(0, 2)}.50`;
  } else if (minute == '45') {
    period = `${period.slice(0, 2)}.75`;
  }

  let colorClass = '';
  switch (status) {
    case WORK_DAY_WORKER_STATUS.automatic:
      colorClass = 'text--positive';
      break;
    case WORK_DAY_WORKER_STATUS.manual:
      colorClass = 'text--red--primary';
      break;
    default:
      break;
  }

  const selectTagClass = `form-list__select--man-hours ${colorClass}`;

  return (
    <div className='form-container__item'>
      <select
        className={selectTagClass}
        name='working_temp_person'
        value={worker.working_temp_person}
        disabled={readOnly}
        onChange={e => callbacks.set(e, foreignKey)}
        onBlur={() => validate('work_dayworkers')} // フォーカスアウト時のバリデーション
      >
        <option value=''>--</option>
        {_.map(SYSTEM_WORKER_COUNT, worker => (
          <option key={worker.id} value={worker.id}>
            {worker.name} 人
          </option>
        ))}
      </select>
      <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
      <span className='form-list__man-hours-line-text form-list__man-hours-line-text--cross'>
        ×
      </span>
      <select
        className={selectTagClass}
        name='working_temp_hour'
        value={Number(worker.working_temp_hour).toFixed(2)}
        disabled={readOnly}
        onChange={e => callbacks.set(e, foreignKey)}
      >
        {_.map(Time, worker => {
          if (isFifteen) {
            if (parseFloat(worker.id2) <= Number(period)) {
              const fixedHour = Number(worker.id2).toFixed(2);
              return (
                <option key={worker.id2} value={fixedHour}>
                  {fixedHour}
                  {isFifteen ? ' 時間' : ' 日'}
                </option>
              );
            }
          } else {
            const fixedHour = Number(worker.id).toFixed(2);
            return (
              // worker.nameとworker.idは同じっぽいのでidを使うようにした
              <option key={worker.id} value={fixedHour}>
                {fixedHour} {isFifteen ? ' 時' : ' 日'}
              </option>
            );
          }
        })}
      </select>
      <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
      <span className='form-list__man-hours-line-text'>=</span>
      <span
        className={`form-list__man-hours-line-result-text ${
          readOnly ? 'form-list__man-hours-line-result-text--disabled' : ''
        } ${
          isWorkHourModal
            ? 'form-list__man-hours-line-result-text--bg-gray'
            : ''
        } ${colorClass}
        `}
      >
        {worker.dayworker && `${worker.dayworker} 人工`}
      </span>
      {foreignKey !== 0 && !readOnly && (
        <button
          className='btn-icon--xs form-list__element--btn_delete'
          onClick={() => callbacks.remove(foreignKey)}
        >
          <TrashIcon className='icon--2_4x form-list__trash-icon' />
        </button>
      )}
      {!_.isUndefined(errors) &&
      !_.isUndefined(errors[foreignKey]) &&
      !_.isNull(errors[foreignKey]) ? (
        <div className='dialog-form__validate'>
          <div className='validate-message show'>{errors[foreignKey]}</div>
        </div>
      ) : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/WorkDayTime.jsx